import { Flex, Text } from "@radix-ui/themes";
import React, { Dispatch, SetStateAction } from "react";
import _, { compact, isUndefined } from "lodash";
import { t } from "i18next";
import { Button } from "../../ui/Button";
import { TbMinus, TbPlus, TbSquare, TbSquareCheckFilled } from "react-icons/tb";
import { GroupingState } from "@tanstack/react-table";

type Props = {
  groupingState: [readonly string[], Function];
  categoryName: string;
  columnId: string;
};

const TableGroupingCategory = ({ groupingState, categoryName, columnId }: Props) => {
  const [grouping, setGrouping] = groupingState;
  const group = grouping.find((group) => group == columnId);
  const index = grouping.findIndex((group) => group == columnId);

  const changeFilter = () => {
    if (isUndefined(group)) {
      setGrouping([...grouping, columnId]);
    } else {
      setGrouping(grouping.filter((group) => group != columnId));
    }
  };

  return (
    <div className="px-1 py-1 rounded bg-muted flex justify-between items-center cursor-pointer hover:bg-primary hover:text-white" onClick={changeFilter}>
      <div className="space-x-2 flex items-center px-1 justify-between w-full">
        <span>{t(categoryName)}</span>
        {index + 1 > 0 && <span className="font-semibold text-xs">{index + 1}</span>}
      </div>
      {isUndefined(group) ? <TbSquare size={18} className="w-6 hover:text-white"/> : <TbSquareCheckFilled size={18} className="w-6 hover:text-white"/>}
    </div>
  );
};

export default TableGroupingCategory;
